import { config } from '../constants/config_constants';
import superAgentRequest from 'superagent';


const USER_AVATAR_URL = `${config.endpoints.BITMOJI_API}user/avatar`;
const WEB_APP_ID = 13; // TODO: ASK DIEGO -> getSearchQuery() used in old code
class BSAccountService {

    static getAvatarInfo(bsAuthToken) {
        return new Promise((resolve, reject) => {

            superAgentRequest
                .get(USER_AVATAR_URL)
                .type('application/x-www-form-urlencoded')
                .set('bitmoji-token', bsAuthToken)
                .send({ app_id: WEB_APP_ID })
                .end((err, res) => {
                    if (err || !res.ok) {
                        reject({
                            statusCode : err,
                            message    : 'Unable to get avatar'
                        });
                    } else {
                        resolve(res.body);
                    }
                });
        });
    }
}

export default BSAccountService;



// WEBPACK FOOTER //
// ./src/services/BSAccountService.js